import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Props {
  permissionData: any;
}

const initialState: Props = {
  permissionData: {},
};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    resetPermissions: () => initialState,
    setPermission: (state: Props, action: PayloadAction<any>) => {
      state.permissionData = action.payload;
    },
  },
});

export const { resetPermissions, setPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
